// Reusable affiliate link component:
//  - Auto-localizes Amazon URLs to visitor's region
//  - Fires GA outbound event on click
//  - Adds the required noopener + sponsored rel attrs
import { useEffect, useState, useCallback } from 'react';
import { localizeAffiliate, trackOutboundClick, detectCountry } from './affiliate';

export default function AffiliateLink({
  href,
  retailer,
  productId,
  productName,
  className,
  children,
  testid,
  ...rest
}) {
  const [resolvedHref, setResolvedHref] = useState(href);
  const [country, setCountry] = useState('US');

  useEffect(() => {
    const c = detectCountry();
    setCountry(c);
    setResolvedHref(localizeAffiliate(href, c));
  }, [href]);

  const handleClick = useCallback(() => {
    trackOutboundClick({
      retailer: retailer || 'amazon',
      product_id: productId,
      product_name: productName,
      country,
    });
  }, [retailer, productId, productName, country]);

  return (
    <a
      href={resolvedHref}
      target="_blank"
      rel="noopener sponsored"
      onClick={handleClick}
      className={className}
      data-testid={testid}
      data-country={country}
      {...rest}
    >
      {children}
    </a>
  );
}
